import { useAppSelector } from '../../types/hooks';
import { useTranslation } from 'react-i18next';
import SidebarLink from '../Elements/SidebarLink';
import React from 'react';
import { colors } from '../../utils/colors';
import { APP_ROUTES } from '../../routes';
import { MdOnlinePrediction } from 'react-icons/md';
import Image from 'react-bootstrap/Image';
import { LandingBackground, LogoGoWhite } from '@minifinder/resources/images';

const Sidebar = () => {
    const { t } = useTranslation();

    const socketsConnected = useAppSelector((s) => s.settings.socketsConnected);

    return (
        <div className="h-sidebar d-none d-lg-block" style={{ backgroundImage: `url(${LandingBackground})` }}>
            <div style={{ position: 'absolute', left: 2.5, top: -2.5 }}>
                <MdOnlinePrediction color={socketsConnected ? colors.white : colors.red} />
            </div>
            <div className="profile-wrapper mb-5">
                <div className="user-image-wrapper">
                    <Image style={{ width: '100%', height: '100%' }} src={LogoGoWhite} />
                </div>
            </div>

            <div className="ms-3">
                <SidebarLink icon={'map'} path={APP_ROUTES.map} title={t('web.sidebar.map')} />
                <SidebarLink icon={'device'} path={APP_ROUTES.devices} title={t('web.sidebar.devices')} />
                {/* <SidebarLink icon={'geofence'} path={APP_ROUTES.geofences} title={t('web.sidebar.geofences')} /> */}
            </div>
        </div>
    );
};

export default React.memo(Sidebar);
